const UNITS_CHANNEL_MANAGER = {
  //getUnitTranslations
  UNITS_CM_UNIT_TRANSLATION: 'UNITS_CM_UNIT_TRANSLATION',
  //getObjectChannelPartners
  UNITS_CM_UNITS_CHANNEL_MANAGER: 'UNITS_CM_UNITS_CHANNEL_MANAGER',
};

export default UNITS_CHANNEL_MANAGER;
